import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Navimumbaiairporttolonavalacab() {



    const cardData = {

keyword: "Navi Mumbai Airport to Lonavala Cabs",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Navi Mumbai Airport to Lonavala Cabs for airport transfers, weekend getaways, family trips, corporate travel, and one-way or round-trip journeys. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus with professional chauffeurs. With 24x7 availability, flight tracking support, transparent pricing, instant booking confirmation, and doorstep pickup from Navi Mumbai Airport, we ensure a smooth, comfortable, and hassle-free journey to Lonavala.",

topPlaces: [
    {
        title: "Tiger Point",
        description:
            "Tiger Point is one of the most famous viewpoints in Lonavala, offering breathtaking valley views, cool mountain air, and spectacular monsoon scenery."
    },
    {
        title: "Bhushi Dam",
        description:
            "Bhushi Dam is a popular tourist attraction known for its flowing water during monsoon, scenic surroundings, and family-friendly atmosphere."
    },
    {
        title: "Pawna Lake",
        description:
            "Pawna Lake is a beautiful lakeside destination famous for camping, boating, photography, and peaceful sunset views amidst nature."
    },
    {
        title: "Rajmachi Fort",
        description:
            "Rajmachi Fort is a historic hill fort and trekking destination offering panoramic views of the Sahyadri mountains and lush green valleys."
    },
    {
        title: "Karla Caves",
        description:
            "Karla Caves are ancient Buddhist rock-cut caves known for their remarkable architecture, carvings, and historical significance."
    },
    {
        title: "Bhaja Caves",
        description:
            "Bhaja Caves are among the oldest Buddhist cave complexes in India, attracting visitors interested in history and heritage."
    },
    {
        title: "Lohagad Fort",
        description:
            "Lohagad Fort is a famous trekking destination near Lonavala known for its impressive fortifications and scenic hilltop views."
    },
    {
        title: "Lion’s Point",
        description:
            "Lion’s Point offers stunning views of valleys, waterfalls, and mist-covered mountains, making it a favorite monsoon attraction."
    },
    {
        title: "Della Adventure Park",
        description:
            "Della Adventure Park is one of India’s leading adventure destinations offering thrilling activities, luxury stays, and entertainment."
    },
    {
        title: "Duke’s Nose",
        description:
            "Duke’s Nose is a popular cliff viewpoint and trekking destination known for its dramatic landscape and panoramic Western Ghats scenery."
    }
],



services: [
{
name: "Navi Mumbai to Lonavala Cab",
description: "Mumbai Airport Cab offers Navi Mumbai to Lonavala Cab service for comfortable, safe, and reliable travel between Navi Mumbai and the beautiful hill station of Lonavala. Whether you are planning a family vacation, weekend getaway, corporate outing, sightseeing tour, honeymoon trip, or leisure travel, we provide a wide range of well-maintained vehicles including Sedan, SUV, Innova, Innova Crysta, Ertiga, Kia Carens, and Tempo Traveller. Our experienced chauffeurs ensure smooth driving through the Mumbai-Pune Expressway, timely pickups, luggage assistance, and a stress-free travel experience. With transparent pricing, 24x7 customer support, flexible travel schedules, and doorstep pickup service, we make your Lonavala journey comfortable and memorable from start to finish."
},
{
name: "Navi Mumbai to Lonavala Cab Fare",
description: "Navi Mumbai to Lonavala Cab Fare with Mumbai Airport Cab is affordable, transparent, and designed to suit different travel budgets. We provide competitive rates for Sedan, SUV, Innova, and premium vehicles with no hidden charges. Passengers can choose one-way or round-trip options and enjoy comfortable travel with professional chauffeur service."
},
{
name: "Navi Mumbai Airport to Lonavala Cabs",
description: "Navi Mumbai Airport to Lonavala Cabs service offers reliable airport transfers directly from Navi Mumbai Airport to Lonavala. Mumbai Airport Cab provides clean vehicles, experienced drivers, and smooth transportation for tourists, families, and business travellers looking for hassle-free travel to the hill station."
},
{
name: "Navi Mumbai Airport to Lonavala Cab",
description: "Navi Mumbai Airport to Lonavala Cab service provides convenient and comfortable airport-to-destination transfers. Our professional chauffeurs ensure timely airport pickups, luggage assistance, and safe travel through the expressway, making your journey pleasant and relaxing."
},
{
name: "Navi Mumbai Airport to Lonavala Taxi",
description: "Navi Mumbai Airport to Lonavala Taxi service offers dependable transportation with air-conditioned vehicles and experienced drivers. Mumbai Airport Cab ensures punctual service, comfortable seating, and smooth travel for all passengers arriving at the airport."
},
{
name: "Cab from Navi Mumbai Airport to Lonavala",
description: "Cab from Navi Mumbai Airport to Lonavala service provides direct pickup from the airport and comfortable transfer to Lonavala. Mumbai Airport Cab ensures professional chauffeurs, well-maintained vehicles, and a safe journey throughout the route."
},
{
name: "Taxi from Navi Mumbai Airport to Lonavala",
description: "Taxi from Navi Mumbai Airport to Lonavala service offers a convenient travel solution for passengers arriving at the airport. We provide comfortable vehicles, courteous drivers, and reliable service for smooth transportation to Lonavala."
},
{
name: "Book Cab Navi Mumbai Airport to Lonavala",
description: "Book Cab Navi Mumbai Airport to Lonavala service allows passengers to reserve their airport transfer in advance with instant confirmation. Mumbai Airport Cab ensures easy booking, transparent pricing, and guaranteed vehicle availability."
},
{
name: "Online Cab Booking Navi Mumbai Airport to Lonavala",
description: "Online Cab Booking Navi Mumbai Airport to Lonavala service provides a quick and convenient way to secure transportation through digital booking. Mumbai Airport Cab offers seamless reservations, multiple vehicle options, and 24x7 customer support."
},
{
name: "Best Cab Navi Mumbai Airport to Lonavala",
description: "Best Cab Navi Mumbai Airport to Lonavala service delivers premium travel experience with professional chauffeurs, clean vehicles, and dependable transportation. Mumbai Airport Cab focuses on passenger comfort, punctuality, and service quality."
},
{
name: "Cheapest Cab Navi Mumbai Airport to Lonavala",
description: "Cheapest Cab Navi Mumbai Airport to Lonavala service offers budget-friendly transportation without compromising safety or reliability. Mumbai Airport Cab provides economical travel options with professional service and comfortable vehicles."
},
{
name: "Reliable Taxi Navi Mumbai Airport to Lonavala",
description: "Reliable Taxi Navi Mumbai Airport to Lonavala service ensures passengers receive safe, punctual, and dependable transportation. Mumbai Airport Cab provides experienced drivers, well-maintained vehicles, and excellent travel support."
},
{
name: "One Way Cab Navi Mumbai Airport to Lonavala",
description: "One Way Cab Navi Mumbai Airport to Lonavala service is ideal for travellers requiring a single-drop journey without return charges. Mumbai Airport Cab offers affordable pricing, comfortable vehicles, and smooth travel experience."
},
{
name: "Round Trip Cab Navi Mumbai Airport to Lonavala",
description: "Round Trip Cab Navi Mumbai Airport to Lonavala service provides complete travel solutions for passengers planning return journeys. Mumbai Airport Cab offers flexible schedules, waiting options, and reliable transportation for convenient travel."
},
{
name: "Airport Pickup Cab Navi Mumbai to Lonavala",
description: "Airport Pickup Cab Navi Mumbai to Lonavala service ensures timely pickup from Navi Mumbai Airport and direct transfer to Lonavala. Mumbai Airport Cab monitors arrival schedules and provides professional assistance for a seamless journey."
},
{
name: "Innova Cab Navi Mumbai Airport to Lonavala",
description: "Innova Cab Navi Mumbai Airport to Lonavala service offers spacious and comfortable transportation for families and groups. Mumbai Airport Cab provides premium seating, ample luggage space, professional chauffeurs, and a smooth ride experience throughout the journey."
}
],

tableData: [
["Navi Mumbai to Lonavala Cab","Navi Mumbai to Lonavala Cab Fare"],
["Navi Mumbai Airport to Lonavala Cabs","Navi Mumbai Airport to Lonavala Cab"],
["Navi Mumbai Airport to Lonavala Taxi","Cab from Navi Mumbai Airport to Lonavala"],
["Taxi from Navi Mumbai Airport to Lonavala","Book Cab Navi Mumbai Airport to Lonavala"],
["Online Cab Booking Navi Mumbai Airport to Lonavala","Best Cab Navi Mumbai Airport to Lonavala"],
["Cheapest Cab Navi Mumbai Airport to Lonavala","Reliable Taxi Navi Mumbai Airport to Lonavala"],
["One Way Cab Navi Mumbai Airport to Lonavala","Round Trip Cab Navi Mumbai Airport to Lonavala"],
["Airport Pickup Cab Navi Mumbai to Lonavala","Innova Cab Navi Mumbai Airport to Lonavala"]
],













whychoose: [
    {
        WhyChooseheading: "Reliable Navi Mumbai Airport to Lonavala Cab Service",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Navi Mumbai Airport to Lonavala Cab services for tourists, families, couples, corporate travelers, and weekend vacationers seeking comfortable transportation."
    },
    {
        WhyChooseheading: "Direct Airport to Lonavala Transfer",
        WhyChoosedescription: "Passengers arriving at Navi Mumbai Airport can enjoy hassle-free direct transportation to Lonavala without changing trains, buses, or multiple travel options."
    },
    {
        WhyChooseheading: "Perfect for Weekend Getaways and Holidays",
        WhyChoosedescription: "Lonavala is one of Maharashtra's most popular hill stations, attracting visitors for vacations, sightseeing, monsoon trips, and relaxing weekend escapes."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to passenger count and luggage requirements."
    },
    {
        WhyChooseheading: "One-Way and Round Trip Facilities",
        WhyChoosedescription: "Whether you require a one-way airport transfer, same-day return, round trip, or customized sightseeing package, we provide flexible travel solutions."
    },
    {
        WhyChooseheading: "Flight Monitoring and Timely Pickup",
        WhyChoosedescription: "Our team tracks flight schedules and adjusts pickup timings to ensure passengers receive timely airport transportation even during delays."
    },
    {
        WhyChooseheading: "Experienced Drivers for Expressway Travel",
        WhyChoosedescription: "Our professional chauffeurs are experienced on the Mumbai-Pune Expressway and hill station routes, ensuring safe and comfortable travel."
    },
    {
        WhyChooseheading: "Ideal for Families, Tourists, and Groups",
        WhyChoosedescription: "From couples and families to corporate teams and tourist groups, we provide suitable vehicles for every airport transfer requirement."
    }
]
};

const faqData = [
    {
        question: "Why do travelers book Navi Mumbai Airport to Lonavala Cabs?",
        answer: "Many travelers prefer direct cab transportation for convenience, comfort, sightseeing trips, weekend holidays, and family vacations."
    },
    {
        question: "Can I book a one-way cab from Navi Mumbai Airport to Lonavala?",
        answer: "Yes, one-way cab services are available along with round-trip and customized travel packages."
    },
    {
        question: "Which vehicle is suitable for Navi Mumbai Airport to Lonavala travel?",
        answer: "Sedan cars, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, and Mini Buses are available according to passenger count and luggage requirements."
    },
    {
        question: "Do you provide airport pickup from all terminals?",
        answer: "Yes, pickup services are available from all operational terminals at Navi Mumbai Airport."
    },
    {
        question: "Can families book airport cabs for Lonavala vacations?",
        answer: "Yes, many families choose our airport cab service for comfortable travel directly to resorts, hotels, villas, and holiday destinations in Lonavala."
    },
    {
        question: "Are Tempo Travellers available for group airport transfers?",
        answer: "Yes, Tempo Travellers and Mini Buses are available for family groups, tourists, corporate outings, and group vacations."
    },
    {
        question: "Will the driver wait if my flight is delayed?",
        answer: "Yes, flight schedules are monitored and pickup timings are adjusted according to actual arrival times."
    },
    {
        question: "Can sightseeing places be included during the trip?",
        answer: "Yes, customers can customize their itinerary and visit Tiger Point, Bhushi Dam, Rajmachi Point, Pawna Lake, Wax Museum, and other attractions."
    },
    {
        question: "Is advance booking recommended for Navi Mumbai Airport to Lonavala travel?",
        answer: "Yes, advance booking is recommended to secure your preferred vehicle, especially during weekends, holidays, and monsoon seasons."
    },
    {
        question: "How can I book a Navi Mumbai Airport to Lonavala Cab?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Akash Desai",
        feedback:
            "After landing at Navi Mumbai Airport, we headed straight to Lonavala for a weekend getaway. The cab was comfortable, the driver was professional, and the journey was extremely pleasant.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Pallavi Kulkarni",
        feedback:
            "Our airport transfer to Lonavala was perfectly managed. The vehicle was clean, spacious, and we reached our resort comfortably without any travel stress.",
        rating: 5
    }
];



























   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];














const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Navi Mumbai Airport to Lonavala Cabs",
"image": "https://www.mumbaiairportcabs.com/assets/images/navi-mumbai-airport-to-lonavala-cab.jpg",
"description": "Book Navi Mumbai Airport to Lonavala cab service for safe and comfortable hill station travel. Mumbai Airport Cabs offers reliable airport pickup and drop taxi service with professional drivers, flexible one-way and round-trip options, and 24x7 availability.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/navi-mumbai-airport-to-lonavala-cabs"
}
};




    return (
        <div>


<Helmet>
  <title>Navi Mumbai Airport to Lonavala Cabs | Hill Station Taxi | +91 9545731161</title>

<meta
 name="description"
 content="Book Navi Mumbai Airport to Lonavala cab for safe hill station travel. Comfortable airport taxi service with professional drivers, one-way and round-trip options, and 24x7 availability."
/>

<meta
 name="keywords"
 content="navi mumbai to lonavala cab, navi mumbai to lonavala cab fare, navi mumbai airport to lonavala cabs, navi mumbai airport to lonavala taxi, cab from navi mumbai airport to lonavala, taxi from navi mumbai airport to lonavala, book cab navi mumbai airport lonavala"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>







            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/31.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Navimumbaiairporttolonavalacab;